<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.3/jquery.min.js" type="text/javascript"></script>
<div [ngClass]="'dash-wrap ' + extend " (window:resize)="fn_OnResize($event)">
  <app-sidebar></app-sidebar>
  <app-header *ngIf="extend === ''" class="store-admin-header"></app-header>
  <router-outlet></router-outlet>
  <br/>
  <!-- <footer [ngClass]="'dash-fxfooter ' + ((extend==='no-margin')?'shopify':'') ">
    <div class="footer-bottom">
      <ul>
        <li>Copyright ©  MerchLoop</li>
        <li>&nbsp; All Rights Reserved</li>
      </ul>
    </div>
  </footer> -->
</div>
